import { STANDARD_EVENTS_ALLOWED_KEY_METRICS } from "@intelligems/ig-types";

export function buildMetricDefinitionsMarkdown(): string {
  const header = "| metric | label | description |";
  const separator = "| --- | --- | --- |";
  const rows = Object.values(STANDARD_EVENTS_ALLOWED_KEY_METRICS).map((m) => {
    const description = (m.description ?? "").replace(/\|/g, "\\|");
    return `| ${m.analyticsMetricId} | ${m.name} | ${description} |`;
  });
  return [header, separator, ...rows].join("\n");
}
